// iluminacao.jsx
// Configuração centralizada dos circuitos de iluminação

export const iluminacaoConfig = [
  { id: "grupo01", modulo: "1", idx: "1", descricao: "Pergolado", lightType: "normal",
    multipleInstances:[
    { x: 52, y: 70.5, width: 2.5, height: 5, circleNumber:1 },
    { x: 56, y: 68, width: 2.5, height: 5, circleNumber:1 }
    ]},

  { id: "grupo02", modulo: "1", idx: "2", descricao: "Eclusa Social", lightType: "mixed",
    normalLights:[{ x: 52, y: 61.5, width: 2.5, height: 5, circleNumber:2 }],

    ledStrips:[
      { x: 0, y: 39, width: 10, height: 5, isLedStrip: true, ledPath: "M 249 654 H 384", ledColor: "#00b8ff", ledMode: "static"},
      { x: 11, y: 6.75, width: 5, height: 5, isLedStrip: true, ledPath: "M 710 1275 H 710 797 V 1215", ledColor: "#00b8ff", ledMode: "static"},
    ]

   },
  { id: "grupo03", modulo: "1", idx: "3", descricao: "Hall Social", lightType: "mixed", 
    normalLights:[
    { x: 52, y: 55, width: 2.5, height: 5, circleNumber:3 },
    { x: 55, y: 55, width: 2.5, height: 5, circleNumber:3 },
    { x: 62, y: 55, width: 2.5, height: 5, circleNumber:3 }
  ],
  ledStrips:[
    { x: 0.25, y: -22.5, width: 10, height: 14.5, isLedStrip: true, ledPath: "M 498 622 V 551 L 510 488 H 581", ledColor: "#00b8ff", ledMode: "static"},
  ]
 },
  

  { id: "grupo04", modulo: "1", idx: "4", descricao: "Hall e Eclusa Serviço", x: 59, y: 62.5, width: 2.5, height: 5, circleNumber:4, lightType: "normal", },

  { id: "grupo05", modulo: "1", idx: "5", descricao: "Espetos Jardim Externo", x: 51, y: 75, width: 2.5, height: 5, lightType: "normal",
  multipleInstances:[
  { x: 53.5, y: 75.25, width: 2.5, height: 5, circleNumber: 5 },
  { x: 47.5, y: 75.25, width: 2.5, height: 5, circleNumber: 5 }
  ]},
  { id: "grupo06", modulo: "1", idx: "6", descricao: "Espelhos Dagua Externo", x: 68, y: 72, width: 2.5, height: 5, circleNumber: 6, lightType: "normal",},
 
  { id: "grupo07", modulo: "1", idx: "7", descricao: "Postes", lightType: "normal", 
    multipleInstances: [
    { x: 7.75, y: 57.5, width: 2.5, height: 5, circleNumber:7 }, //1
    { x: 7.75, y: 63, width: 2.5, height: 5, circleNumber:7 }, //2
    { x: 9.5, y: 67.5, width: 2.5, height: 5, circleNumber:7 },   //3
    { x: 13, y: 70, width: 2.5, height: 5, circleNumber:7 },  //4
    { x: 17.5, y: 70.5, width: 2.5, height: 5, circleNumber:7 },    //5
    { x: 21.75, y: 71, width: 2.5, height: 5, circleNumber:7 },    //6
    { x: 26.75, y: 71.75, width: 2.5, height: 5, circleNumber:7 },    //7
    { x: 31.5, y: 72.5, width: 2.5, height: 5, circleNumber:7 },    //8
    { x: 34.5, y: 70, width: 2.5, height: 5, circleNumber:7 },    //9
    { x: 73.5, y: 76, width: 2.5, height: 5, circleNumber:7 },    //10
    { x: 73.5, y: 65, width: 2.5, height: 5, circleNumber:7 },    //11
    { x: 73.5, y: 58, width: 2.5, height: 5, circleNumber:7 },    //12
    { x: 73.5, y: 45.5, width: 2.5, height: 5, circleNumber:7 },    //13
    { x: 73.5, y: 32.5, width: 2.5, height: 5, circleNumber:7 },    //14
    { x: 73.5, y: 20.5, width: 2.5, height: 5, circleNumber:7 }     //15
  ]},

  { id: "grupo08", modulo: "1", idx: "8", descricao: "Jardim", x: 0, y: 0, width: 0, height: 0 },

  { id: "grupo09", modulo: "2", idx: "1", descricao: "Pergolado Brinquedoteca", lightType: "normal",
    multipleInstances: [
    { x: 70.25, y: 43, width: 2.5, height: 5, circleNumber:9 },
    { x: 70.25, y: 49.75, width: 2.5, height: 5, circleNumber:9 }
    ]},

  // TERREO CIRCUITOS 10 - 19
  { id: "grupo10", modulo: "2", idx: "2", descricao: "Piscina", lightType: "ledStrip", x: 0, y: -27, width: 10, height: 15, isLedStrip: true, ledPath: "M 255 598 H 351", ledColor: "#00b8ff", ledMode: "static" },
  { id: "grupo11", modulo: "2", idx: "3", descricao: "Teto Piscina Aquecida", lightType: "mixed", 
    ledStrips: [
      {x: 0, y: -27.5, width: 10, height: 15, isLedStrip: true, ledPath: "M 377 657 H 254", ledColor: "#00b8ff", ledMode: "static" },
      {x: 0.2, y: -27.5, width: 10, height: 15, isLedStrip: true, ledPath: "M 235 647 V 545 H 461", ledColor: "#00b8ff", ledMode: "static" },
    ]},

  { id: "grupo12", modulo: "2", idx: "4", descricao: "Rampa Circulação Piscina", lightType: "normal",
    multipleInstances: [
    { x: 41, y: 58, width: 2.5, height: 5, circleNumber: 12 },
    { x: 48.5, y: 58, width: 2.5, height: 5, circleNumber: 12 },
    { x: 53, y: 58, width: 2.5, height: 5, circleNumber: 12 },
    ]},

  { id: "grupo13", modulo: "2", idx: "5", descricao: "Hall Circulação", lightType: "normal",
    multipleInstances: [
    { x: 60.5, y: 56, width: 2.5, height: 5, circleNumber: 13 },
    { x: 58.5, y: 50, width: 2.5, height: 5, circleNumber: 13 },
    ]},

  { id: "grupo14", modulo: "2", idx: "6", descricao: "Escada", x: 53.5, y: 51, width: 2.5, height: 5, circleNumber: 14, lightType: "normal", },
  { id: "grupo15", modulo: "2", idx: "7", descricao: "Aquática Piscina", lightType: "normal",
    multipleInstances: [
    { x: 42, y: 45, width: 2.5, height: 5, circleNumber: 15 },
    { x: 44, y: 18, width: 2.5, height: 5, circleNumber: 15 },
    ]},

  { id: "grupo16", modulo: "2", idx: "8", descricao: "Fita Led Piscina", lightType: "normal",
    multipleInstances: [
    { x: 51.5, y: 16, width: 2.5, height: 5, circleNumber: 16 }, //0
    { x: 41, y: 22, width: 2.5, height: 5, circleNumber: 16 }, //1
    { x: 41, y: 30, width: 2.5, height: 5, circleNumber: 16 }, //2
    { x: 41, y: 39, width: 2.5, height: 5, circleNumber: 16 }, //3
    { x: 40, y: 49, width: 2.5, height: 5, circleNumber: 16 }, //4
    { x: 31.5, y: 48.5, width: 2.5, height: 5, circleNumber: 16 }, //5
    { x: 24, y: 47, width: 2.5, height: 5, circleNumber: 16 }, //6
    { x: 19, y: 47, width: 2.5, height: 5, circleNumber: 16 }, //7
    { x: 10.5, y: 47, width: 2.5, height: 5, circleNumber: 16 }, //8
    { x: 10.5, y: 58.5, width: 2.5, height: 5, circleNumber: 16 }, //9
    { x: 11.5, y: 68, width: 2.5, height: 5, circleNumber: 16 }, //10
    { x: 18.5, y: 68, width: 2.5, height: 5, circleNumber: 16 }, //11
    { x: 25, y: 69.5, width: 2.5, height: 5, circleNumber: 16 }, //12
    { x: 33, y: 69.5, width: 2.5, height: 5, circleNumber: 16 }, //13
    { x: 45.5, y: 55.5, width: 2.5, height: 5, circleNumber: 16 }, //14
    { x: 49.5, y: 42, width: 2.5, height: 5, circleNumber: 16 }
    ]},

  { id: "grupo17", modulo: "3", idx: "1", descricao: "Fita Led Praça", width: 2.5, height: 5, lightType: "mixed", 
    normalLights:[
    { x: 49.5, y: 47.5, width: 2.5, height: 5, circleNumber: 17 },
    { x: 49.5, y: 53, width: 2.5, height: 5, circleNumber: 17 },
    ],
    ledStrips:[
      { x: 0.2, y: -13, width: 10, height: 12.2, isLedStrip: true, ledPath: "M 461 554 V 262 H 680", ledColor: "#00b8ff", ledMode: "static"},
    ]},

  { id: "grupo18", modulo: "3", idx: "2", descricao: "Estar / Hall", x: 55.5, y: 44.5, width: 2.5, height: 5, circleNumber: 18, lightType: "normal", },


  { id: "grupo19", modulo: "3", idx: "3", descricao: "Vigia Térreo", width: 2.5, height: 5, lightType: "mixed",
    normalLights:[
    { x: 17.5, y: 56, width: 2.5, height: 5, circleNumber: 19 },
    { x: 29, y: 56, width: 2.5, height: 5, circleNumber: 19 },
    { x: 59, y: 38.5, width: 2.5, height: 5, circleNumber: 19 },
    { x: 56, y: 21.75, width: 2.5, height: 5, circleNumber: 19 },
    { x: 42.5, y: 24.5, width: 2.5, height: 5, circleNumber: 19 },
    ],
    ledStrips:[
      { x: 0.2, y: -23, width: 10, height: 15, isLedStrip: true, ledPath: "M 408 356 V 476", ledColor: "#00b8ff", ledMode: "static"},
    ]},
    
  // SUBSOLO VIGIA SS1 e SS2
  { id: "grupo20", modulo: "3", idx: "4", descricao: "Vigia SS2", lightType: "normal", 
    multipleInstances: [
      { x: 20, y: 59, width: 2.5, height: 5, circleNumber: 20 },
      { x: 43, y: 59, width: 2.5, height: 5, circleNumber: 20 },
      { x: 42.5, y: 20, width: 2.5, height: 5, circleNumber: 20 },
      { x: 59.5, y: 33, width: 2.5, height: 5, circleNumber: 20 },
      { x: 57, y: 58, width: 2.5, height: 5, circleNumber: 20 },
    ]
  },
  
  { id: "grupo21", modulo: "3", idx: "5", descricao: "Vigia SS1", lightType: "normal", 
    multipleInstances: [
      { x: 20, y: 57, width: 2.5, height: 5, circleNumber: 21 },
      { x: 43, y: 57, width: 2.5, height: 5, circleNumber: 21 },
      { x: 44, y: 16, width: 2.5, height: 5, circleNumber: 21 },
      { x: 60, y: 36, width: 2.5, height: 5, circleNumber: 21 },
      { x: 57, y: 56, width: 2.5, height: 5, circleNumber: 21 },
    ]
  },

    { id: "grupo24", modulo: "4", idx: "1", descricao: "Acionamento piscina 1", x: 0, y: 0, width: 0, height: 0 },
    { id: "grupo25", modulo: "4", idx: "2", descricao: "Acionamento piscina 2", x: 0, y: 0, width: 0, height: 0 },
    { id: "grupo26", modulo: "4", idx: "3", descricao: "Acionamento piscina 3", x: 0, y: 0, width: 0, height: 0 },
    { id: "grupo27", modulo: "4", idx: "4", descricao: "Acionamento piscina 4", x: 0, y: 0, width: 0, height: 0 },
    { id: "grupo28", modulo: "4", idx: "5", descricao: "Acionamento piscina 5", x: 0, y: 0, width: 0, height: 0 },
    { id: "grupo29", modulo: "4", idx: "6", descricao: "Acionamento piscina 6", x: 0, y: 0, width: 0, height: 0 },
    { id: "grupo30", modulo: "4", idx: "7", descricao: "Acionamento piscina 7", x: 0, y: 0, width: 0, height: 0 },
    { id: "grupo31", modulo: "4", idx: "8", descricao: "Chafaris piscina", x: 0, y: 0, width: 0, height: 0 },
];


// Função útil para obter informações de ON/OFF para cada circuito
export const getCircuitOnOffValues = (circuitNumber) => {
  const circuitIndex = circuitNumber - 1;
  if (circuitIndex < 0 || circuitIndex >= iluminacaoConfig.length) {
    return null;
  }
  
  const circuit = iluminacaoConfig[circuitIndex];
  return {
    descricao: circuit.descricao,
    onValue: JSON.stringify({ modulo: circuit.modulo, idx: circuit.idx, status: "ON" }),
    offValue: JSON.stringify({ modulo: circuit.modulo, idx: circuit.idx, status: "OFF" })
  };
};